<div *ngIf="!isEditing && clickToEdit" (click)="startEditing()" class="click-to-edit-area">
    <nz-tag *ngFor="let labelId of currentValue" [nzColor]="labelInfos[labelId] ? labelInfos[labelId].color : ''" class="label-tag">
        {{ labelInfos[labelId] ? labelInfos[labelId].labelName : '' }}
    </nz-tag>
</div>

<ng-container *ngIf="isEditing || !clickToEdit">
    <nz-select
            #selectComponent
            [(ngModel)]="currentValue"
            [(nzOpen)]="openMenu"
            nzMode="multiple"
            class="select-tag-panel"
            [nzLoading]="loading"
            [nzRemoveIcon]="removeIconTemplate"
            nzShowSearch
            nzAllowClear
            (ngModelChange)="changeSelect($event)"
            [nzCustomTemplate]="defaultTemplate"
            [nzDropdownRender]="showAdd ? renderTemplate : null"
            (nzOpenChange)="openChange($event)"
    >
        <nz-option *ngFor="let item of options"  nzCustomContent [nzLabel]="item.labelName" [nzValue]="item.id">
            <nz-tag [nzColor]="item.color">{{item.labelName}}</nz-tag>
        </nz-option>
    </nz-select>
    <ng-template #removeIconTemplate>
    </ng-template>
    <ng-template #defaultTemplate let-selected>
        <nz-tag [nzColor]="labelInfos[selected.nzValue].color">
            {{ selected.nzLabel }}
        </nz-tag>
    </ng-template>
    <ng-template #renderTemplate>
        <nz-divider></nz-divider>
        <div class="label-render-container">
            <nz-color-picker nzFormat="hex" #labelColorEl></nz-color-picker>
            <input type="text" nz-input #labelNameEl/>
            <a class="add-item" (click)="handleAdd(labelNameEl, labelColorEl)">
                <span nz-icon nzType="plus"></span>
                Add item
            </a>
        </div>
    </ng-template>
</ng-container>
